import NuevoUsuario from "./NuevoUsuario";
export default NuevoUsuario;
